var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 202.082,
    height: 202.082,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.192 144.116C187.192 167.906 167.906 187.192 144.116 187.192H57.9657C34.1758 187.192 14.8903 167.906 14.8903 144.116C14.8903 125.645 26.5164 109.89 42.8501 103.768M14.8903 57.9657C14.8903 34.1758 34.1758 14.8903 57.9657 14.8903H144.116C167.906 14.8903 187.192 34.1758 187.192 57.9657C187.192 76.4367 175.566 92.1924 159.232 98.3143M42.8501 103.768L27.5272 88.4448C10.7052 71.6228 10.7052 44.349 27.5272 27.527C44.3492 10.705 71.623 10.705 88.445 27.527L159.232 98.3143L174.555 113.637C191.377 130.459 191.377 157.732 174.555 174.554C157.733 191.376 130.459 191.376 113.637 174.554L42.8501 103.768Z",
    stroke: "#171717",
    strokeWidth: 8.10831
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLogo);
export default __webpack_public_path__ + "static/media/SLogo.67a4d43db0fb2c65e1f7245cc5a59718.svg";
export { ForwardRef as ReactComponent };